module.exports = __webpack_public_path__ + "static/media/signup-bg.dafe641b.png";